import api from 'api';

export const loadPartnerAudienceTable = api('POST /api/partner-audiences/grid');
export const loadPartnerAudienceDetails = api(
  'GET /api/partner-audiences/:id/details'
);
export const loadPartnerAudience = api('GET /api/partner-audiences/:id');
export const createPartnerAudience = api('POST /api/partner-audiences');
export const updatePartnerAudience = api('PUT /api/partner-audiences/:id');
export const archivePartnerAudience = api(
  'POST /api/partner-audiences/:id/archive'
);
export const restorePartnerAudience = api(
  'POST /api/partner-audiences/:id/restore'
);
export const syncPartnerAudience = api('POST /api/partner-audiences/:id/sync');
export const batchSyncPartnerAudience = api(
  'POST /api/partner-audiences/batch/sync'
);

export const deletePartnerAudience = api(
  'POST /api/partner-audiences/:id/delete'
);
export const batchDeletePartnerAudience = api(
  'POST /api/partner-audiences/batch/delete'
);

export const toggleAutoSyncPartnerAudience = api(
  'PATCH /api/partner-audiences/:id/toggle-auto-sync'
);

export const loadPartnerAudiencesActionsLog = api(
  'GET /api/partner-audiences/:id/details/actionsLog'
);

export const exportGridPartnerAudiences = api(
  'POST /api/partner-audiences/grid/export'
);

export const setReceiveNotification = api(
  'PUT /api/partner-audiences/:id/set-receive-notification'
);
